import Vue from "vue/dist/vue.min.js";
import videoPosterPlayer from "./sub-components/videoPosterPlayer";

const vm = new Vue({
  el: "#homeApp",
  delimiters: ["${", "}"],
  components: {
    "video-poster": videoPosterPlayer,
  },
});
